export const Types = {
  SAVE_DASHBOARD_DATA: 'SAVE_DASHBOARD_DATA',
  SAVE_ORDER_TRACKING: 'SAVE_ORDER_TRACKING',
  SAVE_BUYER_TRACKING: 'SAVE_BUYER_TRACKING',
  SAVE_GMV_TRACKING: 'SAVE_GMV_TRACKING',
  SAVE_CASHBACK_TRACKING: 'SAVE_CASHBACK_TRACKING',
  SAVE_TOKEN_TRACKING: 'SAVE_TOKEN_TRACKING',
  SAVE_WALLET_MONEY: 'SAVE_WALLET_MONEY',
  SAVE_WALLET_TOKEN: 'SAVE_WALLET_TOKEN',
  SAVE_WITHDRAW_TOKEN: 'SAVE_WITHDRAW_TOKEN',
  SAVE_WITHDRAW_TOKEN_VALUE: 'SAVE_WITHDRAW_TOKEN_VALUE',
  SAVE_USER_DAU: 'SAVE_USER_DAU',
  SAVE_TOTAL_USER_DAU: 'SAVE_TOTAL_USER_DAU',
  SAVE_DASHBOARD_HISTORY_DATA: 'SAVE_DASHBOARD_HISTORY_DATA',
  SAVE_USER_DAILY: 'SAVE_USER_DAILY'
}
